import { render, staticRenderFns } from "./chateau-latour-martillac.vue?vue&type=template&id=569abb72&scoped=true"
import script from "./chateau-latour-martillac.vue?vue&type=script&lang=js"
export * from "./chateau-latour-martillac.vue?vue&type=script&lang=js"
import style0 from "./chateau-latour-martillac.vue?vue&type=style&index=0&id=569abb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569abb72",
  null
  
)

export default component.exports